// quantity-bundle.js
// Bundle de quantidade — navegação direta no clique.
//
// Variante fixa da loja + quantidade da opção marcada:
//   3 unidades  -> /cart/47074351546626:3
//   10 unidades -> /cart/47074351546626:10
//   20 unidades -> /cart/47074351546626:20
//
// Não depende de data-checkout-url nem data-variant-id. Funciona com o botão
// sendo <button> ou <a>. Sem estado de "loading" pra travar.

const VOLTA_VIBE_VARIANT_ID = '47074351546626'; // <-- variante fixa da loja

class QuantityBundle {
  constructor(container) {
    this.container = container;

    this.radioButtons = container.querySelectorAll('.quantity-bundle__radio');
    this.buyButton = container.querySelector('.quantity-bundle__buy-button');
    this.comparePriceEl = container.querySelector('.quantity-bundle__compare-price');
    this.comparePriceTextEl = container.querySelector('.quantity-bundle__compare-price-text');
    this.currentPriceEl = container.querySelector('.quantity-bundle__current-price');
    this.pixPriceEl = container.querySelector('.quantity-bundle__pix-price');

    this.baseComparePrice = parseFloat(this.comparePriceEl.dataset.comparePrice) / 100;
    this.baseCurrentPrice = parseFloat(this.currentPriceEl.dataset.currentPrice) / 100;
    this.pixDiscount = parseFloat(this.pixPriceEl && this.pixPriceEl.dataset.pixDiscount) || 1;

    // Descontos por quantidade — usados APENAS para exibir o preço na tela.
    this.quantityDiscounts = {};
    const options = this.container.querySelectorAll('.quantity-bundle__option');
    options.forEach((option, i) => {
      const quantity = parseInt(option.dataset.quantity);
      if (quantity) {
        const discountValue = parseFloat(container.getAttribute('data-option-' + (i + 1) + '-discount')) || 0;
        this.quantityDiscounts[quantity] = discountValue;
      }
    });

    this.selectedQuantity = this.getSelectedQuantity();
    this.init();
  }

  init() {
    this.bindEvents();
    this.updatePrices();
    this.updateVisualSelection();
  }

  bindEvents() {
    this.radioButtons.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        this.selectedQuantity = parseInt(e.target.value);
        this.updatePrices();
        this.updateVisualSelection();
      });
    });

    // Clique no botão → navega direto pro carrinho da variante + quantidade
    this.buyButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.goToCheckout();
    });

    // Clicar em qualquer lugar da opção seleciona o radio
    this.container.querySelectorAll('.quantity-bundle__option').forEach((option) => {
      option.addEventListener('click', (e) => {
        if (e.target.type !== 'radio') {
          const radio = option.querySelector('.quantity-bundle__radio');
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change'));
          }
        }
      });
    });
  }

  goToCheckout() {
    const quantity = parseInt(this.selectedQuantity, 10) || 1;
    const url = '/cart/' + VOLTA_VIBE_VARIANT_ID + ':' + quantity;
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'begin_checkout' });
    }
    window.location.assign(url);
  }

  getSelectedQuantity() {
    const checkedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    return checkedRadio ? parseInt(checkedRadio.value) : 1;
  }

  updatePrices() {
    const quantity = this.selectedQuantity;

    const quantityDiscountPercent = this.quantityDiscounts[quantity] || 0;
    const quantityDiscountDecimal = quantityDiscountPercent / 100;

    const totalComparePrice = this.baseComparePrice * quantity;
    const totalCurrentPriceBeforeDiscount = this.baseCurrentPrice * quantity;
    const totalCurrentPrice = totalCurrentPriceBeforeDiscount * (1 - quantityDiscountDecimal);

    const pixDiscountDecimal = this.pixDiscount / 100;
    const totalPixPrice = totalCurrentPrice * (1 - pixDiscountDecimal);

    this.comparePriceEl.textContent = this.formatPrice(totalComparePrice);
    this.currentPriceEl.textContent = this.formatPrice(totalCurrentPrice);

    this.updateComparePriceVisibility();

    if (this.pixPriceEl) {
      const pixText = this.pixPriceEl.textContent.split(' ').slice(-2).join(' ');
      this.pixPriceEl.innerHTML = this.formatPrice(totalPixPrice) + ' ' + pixText;
    }
  }

  updateVisualSelection() {
    this.container.querySelectorAll('.quantity-bundle__option').forEach((option) => {
      option.classList.remove('quantity-bundle__option--selected');
    });
    const selectedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    if (selectedRadio) {
      const selectedOption = selectedRadio.closest('.quantity-bundle__option');
      if (selectedOption) selectedOption.classList.add('quantity-bundle__option--selected');
    }
  }

  formatPrice(price) {
    return 'R$' + price.toFixed(2).replace('.', ',');
  }

  updateComparePriceVisibility() {
    const selectedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    if (!selectedRadio) return;

    const isOption3 = selectedRadio.id.endsWith('-3');
    const display = isOption3 ? 'none' : '';

    this.comparePriceEl.style.display = display;
    if (this.comparePriceTextEl) this.comparePriceTextEl.style.display = display;
  }
}

// --- Inicialização (uma vez só) ---------------------------------------------
function initQuantityBundles(root) {
  (root || document).querySelectorAll('.quantity-bundle').forEach((bundle) => {
    if (bundle.dataset.bundleReady === 'true') return;
    bundle.dataset.bundleReady = 'true';
    new QuantityBundle(bundle);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initQuantityBundles());
} else {
  initQuantityBundles();
}

document.addEventListener('shopify:section:load', (event) => {
  initQuantityBundles(event.target);
});

window.QuantityBundle = QuantityBundle;